module.exports = __webpack_public_path__ + "img/campfireHeader.7556d764.jpg";